import React, { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'reactstrap'

import { FormFieldController, TextInput, Combobox } from 'components/FormElements'
import { useFetch } from 'hooks'
import { staticAPI } from 'features/static/api'

export const EmployerProfileFormSection = () => {
  const { t } = useTranslation()

  const { control } = useFormContext()

  const { data, fetch } = useFetch()

  useEffect(() => {
    const request = staticAPI.getProfileSelects
    fetch(request, { includes: ['profile_positions'] })
  }, [])

  const profilePositions = useMemo(() => {
    if (data?.data) {
      return data?.data?.profile_positions || []
    }

    return []
  }, [data])

  return (
    <Row>
      <Col md={6}>
        <FormFieldController
          name={'employer_profile.profile_position_id'}
          control={control}
          defaultValue={null}
          component={Combobox}
          id={'employer_profile.profile_position_id'}
          label={t('position')}
          placeholder={t('position')}
          options={profilePositions}
          isSearchable={false}
          isDetermineValue
          normalize={option => (option !== null ? option.id : null)}
          getOptionLabel={option => option.value}
          getOptionValue={option => option.id}
          maxMenuHeight={200}
          // menuPortalTarget={document.querySelector('body')}
        />
      </Col>

      <Col md={6}>
        <FormFieldController
          name={'employer_profile.company_name'}
          control={control}
          component={TextInput}
          id={'employer_profile.company_name'}
          label={t('company_name')}
          placeholder={t('company_name')}
          defaultValue={''}
        />
      </Col>
    </Row>
  )
}
